// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportObjects = {
	88444: function() {
		return {
			"./intl_segmenter_polyfill_rs_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache0["bk"](p0i32);
				},
				"__wbg_segments_new": function(p0i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache1["ZH"](p0i32);
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache2["vU"](p0i32);
				},
				"__wbindgen_in": function(p0i32,p1i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache3["zE"](p0i32,p1i32);
				},
				"__wbindgen_string_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache4["qN"](p0i32,p1i32);
				},
				"__wbindgen_is_object": function(p0i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache5["qv"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache6["yc"](p0i32,p1i32);
				},
				"__wbg_makeiter_99ccd6b658d32814": function(p0i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache7["aE"](p0i32);
				},
				"__wbg_new_abda76e883ba8a5f": function() {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache8["V5"]();
				},
				"__wbg_stack_658279fe44541cf6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache9["u$"](p0i32,p1i32);
				},
				"__wbg_error_f851667af71bcfc6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache10["Xu"](p0i32,p1i32);
				},
				"__wbindgen_object_clone_ref": function(p0i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache11["BZ"](p0i32);
				},
				"__wbindgen_jsval_loose_eq": function(p0i32,p1i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache12["U8"](p0i32,p1i32);
				},
				"__wbindgen_boolean_get": function(p0i32) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache13["Nh"](p0i32);
				},
				"__wbindgen_number_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache14["sW"](p0i32,p1i32);
				},
				"__wbindgen_error_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache15["Rj"](p0i32,p1i32);
				},
				"__wbindgen_number_new": function(p0f64) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache16["QR"](p0f64);
				},
				"__wbindgen_bigint_from_u64": function(p0i64) {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache17["Qg"](p0i64);
				},
				"__wbg_getwithrefkey_4a92a5eca60879b9": function(p0i32,p1i32) {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache18["T9"](p0i32,p1i32);
				},
				"__wbg_set_9182712abebf82ef": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache19["ET"](p0i32,p1i32,p2i32);
				},
				"__wbg_new_9fb8d994e1c0aaac": function() {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache20["hJ"]();
				},
				"__wbg_instanceof_ArrayBuffer_e7d53d51371448e2": function(p0i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache21["tK"](p0i32);
				},
				"__wbg_getPrototypeOf_a6e87842bce6351b": function(p0i32) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache22["u8"](p0i32);
				},
				"__wbg_new_4a703d5c73064dfb": function(p0i32,p1i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache23["gZ"](p0i32,p1i32);
				},
				"__wbg_buffer_a448f833075b71ba": function(p0i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache24["x0"](p0i32);
				},
				"__wbg_new_8f67e318f15d7254": function(p0i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache25["BL"](p0i32);
				},
				"__wbg_set_2357bf09366ee480": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache26["mS"](p0i32,p1i32,p2i32);
				},
				"__wbg_length_1d25fa9e4ac21ce7": function(p0i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache27["IF"](p0i32);
				},
				"__wbg_instanceof_Uint8Array_bced6f43aed8c1aa": function(p0i32) {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache28["M7"](p0i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache29["rl"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache30["Qn"](p0i32,p1i32);
				},
				"__wbindgen_memory": function() {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[8867].exports;
					return wasmImportedFuncCache31["Py"]();
				}
			}
		};
	},
};

var wasmModuleMap = {
	"230": [
		88444
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"230":{"88444":"8c24c73ee6a8578f953f"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};